<template>
  <div class="slider">
    <div class="slider--description" :class="{ 'smaller' : sliderTrackHeight < 12 }">
      <span class="clickable">{{ minDesc }}</span>
      <span v-if="centerText" class="clickable">{{ centerText }}</span>
      <span class="clickable">{{ maxDesc }}</span>
    </div>
    <div class="slider__wrapper">
      <div v-if="!hideLabel" :style="{ left: position }" class="slider__label">
        {{ sliderLabel }}
      </div>
      <div class="slider__track" :style="{ height: `${sliderTrackHeight}px` }">
        <div
          class="slider__track--filled"
          :style="{ width: position, height: `${sliderTrackHeight}px` }"
        ></div>
      </div>
      <input
        ref="slider"
        v-model="sliderValue"
        :max="sliderMax"
        class="slider__input"
        type="range"
        :min="sliderMin"
        :step="step"
        disabled
      />
      <span class="slider__marker" :class="{ 'smaller' : sliderTrackHeight < 12 }" :style="{ left: position }">
        <svg-file name="heart-with-border" :size="sliderTrackHeight * 10 / 3" color="#FF9997" />
      </span>
    </div>
    </div>
</template>

<script>
export default {
  name: 'Slider',
  props: {
    value: {
      type: Number,
      required: false,
      default: 0
    },
    step: {
      type: Number,
      required: false,
      default: 1
    },
    hideLabel: {
      type: Boolean,
      default: true
    },
    sliderTrackHeight: {
      type: Number,
      required: false,
      default: 12
    },
    minDesc: {
      type: String,
      default: ''
    },
    maxDesc: {
      type: String,
      default: ''
    },
    centerText: {
      type: String,
      default: '' // center align button
    }
  },
  data () {
    return {
      sliderWidth: 0,
      sliderValue: 50,
      sliderMax: 100,
      sliderMin: 1
    }
  },
  computed: {
    sliderLabel () {
      return this.sliderValue
    },
    sliderOutputValue () {
      return this.sliderValue
    },
    position () {
      const val = this.sliderValue
      // Measure width of slider element. Adjust by 10 to account for thumbsize
      const width = this.sliderWidth - 5
      // Calculate percentage between left and right of input
      const percent =
        (val - this.sliderMin) / (this.sliderMax - this.sliderMin)
      // Janky value to get pointer to line up better
      const offset = 3
      const position = width * percent + offset
      return `${position}px`
    }
  },
  created () {
    this.sliderValue = this.value
  },
  mounted () {
    this.$nextTick(() => {
      setTimeout(() => {
        this.sliderWidth = this.$refs.slider.clientWidth
      }, 10)
      window.addEventListener(
        'resize',
        () => (this.sliderWidth = this.$refs.slider !== undefined ? this.$refs.slider.clientWidth : 0)
      )
    })
  },
  watch: {
    value (value) {
      this.sliderValue = value
    }
  }
}
</script>

<style lang="less">
@import "./slider.less";
</style>
